// extracted by mini-css-extract-plugin
export default {"grid":"x90FOn","container":"PBKI0F"};